import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.flowStep.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.flowStep.fields.name'),
  },
  {
    name: 'actionType',
    label: i18n('entities.flowStep.fields.actionType'),
  },
  {
    name: 'actionResources',
    label: i18n('entities.flowStep.fields.actionResources'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'actionFolder',
    label: i18n('entities.flowStep.fields.actionFolder'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.flowStep.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.flowStep.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
